import React from 'react';
import { cn } from '@/lib/utils';
import { CheckCircle, Check, XCircle } from 'lucide-react';
import type { ValidationStatus } from '@/types';

interface ValidationBadgeProps {
  status?: ValidationStatus;
  className?: string;
}

export const ValidationBadge: React.FC<ValidationBadgeProps> = ({ status, className }) => {
  if (!status) {
    return null;
  }

  if (!status.validated) {
    return (
      <span className={cn('inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-xs font-medium bg-red-100 text-red-700 border border-red-300', className)}>
        <XCircle className="w-3 h-3" />
        Not Verified
      </span>
    );
  }

  if (status.validated && status.primary) {
    return (
      <span className={cn('inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-xs font-medium bg-blue-100 text-blue-700 border border-blue-300', className)}>
        <CheckCircle className="w-3 h-3" />
        Primary Verified
      </span>
    );
  }

  // Validated but not primary
  return (
    <span className={cn('inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-xs font-medium bg-white text-slate-700 border border-slate-300', className)}>
      <Check className="w-3 h-3" />
      Verified - Not Primary
    </span>
  );
};
